import { useState } from "react";
import { DISCLAIMER_CLOSING, DISCLAIMER_INTRO, DISCLAIMER_POINTS, DISCLAIMER_SHORT, DISCLAIMER_TITLE, DISCLAIMER_VERSION } from "@aigov/domain";
import { api } from "../api";
import { ErrorNote, errMsg } from "../ui";

/** The full notice text, shared by the first-use gate and the Sources tab. */
export function DisclaimerText({ headingLevel = 2 }: { headingLevel?: 2 | 3 }) {
  const H = headingLevel === 2 ? "h2" : "h3";
  return (
    <div className="notice-text">
      <H>{DISCLAIMER_TITLE}</H>
      <p>{DISCLAIMER_INTRO}</p>
      <ul>{DISCLAIMER_POINTS.map((p) => <li key={p}>{p}</li>)}</ul>
      <p><strong>{DISCLAIMER_CLOSING}</strong></p>
    </div>
  );
}

/** Shown before first use, and again whenever the wording changes. */
export function DisclaimerGate({ onAccepted }: { onAccepted: () => void }) {
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  return (
    <section className="panel gate" aria-labelledby="gate-title">
      <span id="gate-title" className="sr-only">{DISCLAIMER_TITLE}</span>
      <DisclaimerText />
      <label className="gate-check">
        <input type="checkbox" id="ack" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
        <span>I understand that this tool gives guidance only, not legal advice, and that I should take advice from qualified legal counsel before relying on its results.</span>
      </label>
      <ErrorNote error={error} />
      <div className="row">
        <button className="btn primary" disabled={!checked || busy} onClick={async () => {
          setBusy(true); setError(null);
          try { await api("POST", "/me/disclaimer", { version: DISCLAIMER_VERSION }); onAccepted(); }
          catch (e) { setError(errMsg(e)); } finally { setBusy(false); }
        }}>Continue</button>
        <span className="muted small">Your acknowledgement is recorded with the date and the version of this notice ({DISCLAIMER_VERSION}).</span>
      </div>
    </section>
  );
}

export function DisclaimerFooter({ onReadMore }: { onReadMore?: () => void }) {
  return (
    <footer className="disclaimer-footer" role="contentinfo">
      <span>{DISCLAIMER_SHORT}</span>
      {onReadMore && <button className="btn ghost small" onClick={onReadMore}>Read the full notice</button>}
    </footer>
  );
}
